module.exports = __webpack_public_path__ + "static/img/rectangle_4.da5b570e.png";